import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import Button from 'components/base/Button';
import { errorHandler } from 'helpers/response-utils';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import FoodPaichart from './FoodPaichart';
import ResponsiveGallery from 'react-responsive-gallery';

// Define types
type NutritionFact = {
  nutrientName: string;
  value: number;
  unitName: string;
};

type Nutrient = {
  name: string;
  nutritionFact: NutritionFact[];
  quantity: string;
  servingSize: number;
  servingSizeUnit: string;
};

type DataItem = {
  extendedProps: {
    createdAt: number;
    mealFile: string;
    notes: string;
    nutrient: Nutrient[];
  };
};

const CalendarFullDatEventModal = ({
  selectedDate,
  handleCloseFullDayEventModal
}: {
  selectedDate: any;
  handleCloseFullDayEventModal: any;
}) => {
  const { id } = useParams();
  const token = localStorage.getItem('token');
  const [currentDayMeals, setCurrentDayMeals] = useState<DataItem[]>([]);
  const [currentDayMealsImage, setCurrentDayMealsImage] = useState<any[]>([]);

  useEffect(() => {
    if (selectedDate != '') {
      getMealByDateRange();
    }
  }, [selectedDate]);

  const getMealByDateRange = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_ENDPOINT}/clinic/meal/getall`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: {
            startDate: moment(selectedDate).format('YYYY-MM-DD'),
            endDate: moment(selectedDate).format('YYYY-MM-DD'),
            patient: id
          }
        }
      );

      if (response.data.status === false) {
        errorHandler(response.data);
        return;
      }
      const data = response.data.data.meals;
      console.log(data);

      const nutrientFact = response.data.data.meals
        .map((item: any) => item.extendedProps.nutrient)
        .flat();
      setCurrentDayMeals(nutrientFact);

      const images = response.data.data.meals
        .map((item: any) => ({ src: item.extendedProps.mealFile }))
        .flat();
      setCurrentDayMealsImage(images);
    } catch (error) {
      console.error('Error occurred:', error);
    }
  };

  const color = ['#ED4D18', '#1ACEDA', '#FEB91A', '#4E7CB6', '#A1A1A1'];
  return (
    <>
      <Modal
        centered
        show={selectedDate != ''}
        onHide={handleCloseFullDayEventModal}
        contentClassName="border"
        size="lg"
      >
        <Modal.Body className="px-card pb-card pt-1 fs-9">
          <Row>
            <Col
              className="m-3"
              style={{
                background: '#e8e8e8',
                padding: '10px',
                borderRadius: '10px'
              }}
            >
              <Modal.Title
                className="modal-title text-body-highlight mb-0"
                style={{ display: 'inline' }}
              >
                Summary {moment(selectedDate).format('DD-MM-YYYY')}
              </Modal.Title>
              <Button
                className="p-1"
                style={{ float: 'right' }}
                onClick={handleCloseFullDayEventModal}
              >
                <FontAwesomeIcon icon={faTimes} className="fs-8" />
              </Button>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12}>
              {currentDayMeals.length ? (
                <FoodPaichart nutrient={currentDayMeals} />
              ) : (
                <p>No Record found!</p>
              )}
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12}>
              {currentDayMealsImage.length ? (
                <ResponsiveGallery useLightBox media={currentDayMealsImage} />
              ) : (
                <p>No Record found!</p>
              )}
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CalendarFullDatEventModal;
